import {
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Image,
  Img,
  Link,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import React from 'react';
import { FaLinkedin } from 'react-icons/fa';

const FundInFocusFirstInvesting: React.FC = () => (
  <>
    {/* members */}
    <Flex
      as="section"
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height={{ xs: '450px', sm: '300px' }}
      minH={{ xs: '450px', sm: '300px' }}
      maxH="450px"
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src="/jpg/blogBanner.jpg"
        alt="members-hero"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
        pos="absolute"
        height="100%"
        width="100%"
        opacity="0.7"
      />
      <Container
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir="column"
        px={{ xs: '20px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
      >
        <Heading
          as="h1"
          mb="20px"
          variant="reportCardTitle"
          fontSize={{ xs: '26px', sm: '28px', md: '32px', lg: '38px' }}
          color="white"
          lineHeight={{ xs: '34px', md: '39px', lg: '42px' }}
        >
          Fund In Focus: Platform-First Investing: Gemba Capital's Formula for
          Sustainable Growth
        </Heading>
        <Text
          fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
          fontWeight="600"
          color="white"
          lineHeight="21px"
        >
          Adith Podhar, Founding Partner,{' '}
          <Link
            href="https://gembacapital.in/"
            target="_blank"
            rel="noreferrer"
          >
            Gemba Capital
          </Link>
        </Text>
      </Container>
    </Flex>
    <Container
      as="section"
      maxW="container.xl"
      pb="80px"
      pt="40px"
      minH="420px"
      display={{ xs: 'flex', md: 'inherit' }}
      flexDirection="column"
    >
      <Box as="main" w="100%" pb="40px">
        <Text variant="blogAnswer">
          Welcome to our ‘Fund in Focus’ series where we profile our member VC
          funds, underscore their investment philosophy, and highlight some of
          their interesting work. In this exclusive chat with Adith Podhar,
          Founding Partner, Gemba Capital where he shares how the firm has
          emerged as a leading micro-VC firm in India, investing in 50+ startups
          with a focus on pre-seed and seed stages. He also threw light on on
          their "platform-first" philosophy, emphasis on founder-market fit, and
          plans for their ₹250 Cr Fund II. By nurturing strong relationships and
          addressing early-stage funding gaps, Gemba is redefining venture
          capital for Indian startups.
        </Text>
      </Box>

      <Img
        src="https://static.levocdn.com/WGLBUT82/Screenshot2024-12-24at123404PM-R6erN5UGmUOU.png"
        alt="Perl"
        boxSize="300px"
        float={{ xs: 'right', md: 'left' }}
        alignSelf={{ xs: 'center', md: 'flex-start' }}
        mx={{ xs: '0px', md: '0px' }}
        mr={{ xs: '0px', md: '40px', lg: '60px', xl: '70px' }}
        mb="20px"
        objectFit="contain"
      />
      <Box>
        <Flex flexDir={{ xs: 'column', lg: 'row' }} rowGap="16px">
          <Heading
            textAlign={{ xs: 'center', md: 'left' }}
            fontWeight="800"
            color="blue.400"
          >
            Spokesperson: Adith Podhar, Founding Partner,{' '}
            <Link
              href="https://gembacapital.in/"
              target="_blank"
              rel="noreferrer"
            >
              Gemba Capital
            </Link>
          </Heading>
          <Flex
            columnGap={{ xs: '4px', md: '16px' }}
            justifyContent={{ xs: 'center', md: 'flex-start' }}
            transform={{ xs: 'translateX(12px)', md: 'none' }}
          >
            <Box alignSelf="start" mt="5px">
              <Link
                href="https://www.linkedin.com/in/adithpodhar/"
                target="_blank"
              >
                <IconButton
                  aria-label="linkedin"
                  icon={
                    <FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />
                  }
                  variant="unstyled"
                  cursor="pointer"
                />
              </Link>
            </Box>
          </Flex>
        </Flex>
        <Box
          ml={{ xs: 'auto', md: '345px', lg: '370px' }}
          mr={{ xs: 'auto', md: '0px' }}
          width={{ xs: '160px', md: '80px' }}
          h="2px"
          bgColor="primary.500"
          borderRadius="5px"
          mt={{ xs: '16px', md: '10px' }}
          mb="15px"
        />
        <Box>
          <Heading variant="blogQuestion" pb="20px" pt="16px" pl="-20px">
            1. Could you walk us through the journey of Gemba Capital since its
            inception in 2018? What were the key milestones that shaped its
            growth into one of India's leading micro-VC firms?
          </Heading>
          <Text variant="blogAnswer" pb="20px">
            Gemba Capital was started by Adith Podhar in 2018 to invest in
            early-stage tech startups led by founders who have an unwavering
            ambition to build world-class businesses. Till date, the firm has
            backed 120+ founders across 50+ startups. Some of the notable
            portfolio companies are Plum (Insurtech), Grip Invest, Wint Wealth,
            UnnatiAgri, Navadhan Capital, Zuper, Showroom, Voltmoney, Smartstaff
            and LightFury games. <br />
            From 2018 to 2021, Gemba Capital was investing proprietary capital
            and running our Syndicate, which we collectively refer to as ‘Fund
            0’. During this period, we invested in 33 companies in pre-seed and
            seed rounds. First two years, we call it building foundational
            blocks wherein time was invested in understanding the nuances of
            seed and pre-seed investing, building our investment thesis,
            evaluation framework and mental models. We also moved our office
            from Mumbai to Bangalore, which is one of the key milestones for us.{' '}
            <br />
            As Covid pandemic struck, 2020 was quite challenging. However, every
            crisis has a silver lining. We started Gemba Capital Syndicate on
            AngelList attracting 500+ members, with some even becoming Limited
            Partners (LPs) in our debut fund - Fund I. Vipul Rawal also joined
            us as a Fintech Venture Partner during this period. From 2021
            onwards, we refined our investment thesis and focused more on
            technology enabled startups across 5-6 sectors. <br />
            The success of ‘Fund 0’ laid the foundation for raising our first
            institutional fund, ‘Fund-I’, of ~Rs. 70 Cr in 2022 through which
            have invested in 20 companies till date. <br />
            In 2023, Govind Lohia joined the team as a Principal and in 2024, we
            received SEBI license for our second fund of ~Rs. 250 Cr focused on
            investing in Fintech, Consumer tech and B2B Platforms. Ranjeet
            Singh, cofounder at Pratilipi joined as Consumer tech Venture
            Partner and Somak Ghosh, founder at Contrarian Capital and banking
            veteran joined as a Board Advisor in 2024. <br />
            Venture Capital is high risk high return asset class and the
            investment manager has to make capital allocation decision in a
            highly uncertain environment, that’s where the GP’s background in
            Private Equity investing, infused a sense of rigor, discipline, and
            framework at Gemba Capital. We operated as institutional VC from day
            zero, a distinctive feature often lacking in the pre-seed/seed stage
            investing landscape in India. We are one of the few micro-VCs who
            are not using the indexing strategy and building a rather
            concentrated portfolio across our focus sectors. <br />
            We have been consistent with our broad investment strategy of
            investing only in pre-seed/seed rounds across our focus sectors,
            investing in <span>&lt;10</span> deals a year and focusing on value
            addition in the portfolio companies.
          </Text>
        </Box>

        {/* Question 2 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            2. The name ‘Gemba’ reflects the concept of "the real workplace" in
            Japanese. How does this philosophy resonate with your work in
            venture capital and your engagement with founders?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Simply put Gemba philosophy means, rolling up your sleeves and
              being on-ground. It’s the shopfloor, the warehouse, the retail
              store where value is created and not the corporate meeting room.
              We believe all answers/solutions to your problems and real truth
              can be found at ‘Gemba’. The term is often used in Lean Management
              to emphasize that real improvement requires a shop-floor focus
              based on direct observation of current conditions. <br /> <br />
              This is the philosophy we try to imbibe when we are evaluating
              deals to make investing decisions and when we engage with our
              portfolio companies.
            </Text>
          </Box>
        </Box>
        {/* Ques 3 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            3. With the target corpus of INR 250 Cr for Fund II, what is the
            vision you aim to achieve with this fund, and how does it differ
            from Fund I?
          </Heading>
          <Box>
            <UnorderedList>
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  <span
                    style={{ fontWeight: 'bold', textDecoration: 'underline' }}
                  >
                    Stage mix -
                  </span>
                  The investment approach for both the funds is consistent and
                  we will continue investing in pre-seed and seed rounds with
                  ~30% reserve allocation for follow-on investments.
                </Text>
              </ListItem>
              <br />
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  <span
                    style={{ fontWeight: 'bold', textDecoration: 'underline' }}
                  >
                    Portfolio Size -
                  </span>
                  Fund II Portfolio size ~30 companies with not more than 10
                  deals per year. The number is slightly higher than Fund-I
                  portfolio of ~24 companies, since our allocation to Consumer
                  tech in Fund-II has increased as compared to Fund-I.
                </Text>
              </ListItem>
              <br />
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  <span
                    style={{ fontWeight: 'bold', textDecoration: 'underline' }}
                  >
                    Focus Sectors -
                  </span>
                  In Fund I, we focused on 4 sectors – Fintech, Consumer tech,
                  Enterprise Software and B2B Platforms. Fintech was key sector
                  in Fund I with over 40% allocation. For Fund II, we intend to
                  raise our Fintech allocation to 50%. Remaining 50% will be
                  split across Consumer tech and B2B Platforms.
                </Text>
              </ListItem>
              <br />
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  <span
                    style={{ fontWeight: 'bold', textDecoration: 'underline' }}
                  >
                    Average Ownership -
                  </span>
                  In Fund II, we will increase our ownership in companies to
                  ~7-9% from the current ~2-5% at Fund-I.
                </Text>
              </ListItem>
              <br />
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  <span
                    style={{ fontWeight: 'bold', textDecoration: 'underline' }}
                  >
                    Average cheque size -
                  </span>
                  Average first cheque size will increase to ~Rs. 5 Cr in
                  Fund-II from the current average of ~Rs. 2 Cr in Fund-I.
                </Text>
              </ListItem>
              <br />
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  <span
                    style={{ fontWeight: 'bold', textDecoration: 'underline' }}
                  >
                    Co-lead/Lead transactionse -
                  </span>
                  In Fund II, we will co-lead or lead transactions.
                </Text>
              </ListItem>
            </UnorderedList>
          </Box>
        </Box>

        {/* Question 4 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            4. Could you elaborate on your emphasis on "platform-first"
            businesses? Why do you believe these businesses create sustainable
            competitive advantages?
          </Heading>
          <Box>
            <UnorderedList>
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  We refer to the platform as a business model. The core value
                  proposition of a platform is to facilitate the exchange of
                  value among network participants by solving for lack of trust,
                  information asymmetry, and operational inefficiencies. This
                  exchange of value can be in the form of products, services, or
                  data. In Fund-II, our thesis is to invest in ‘Platform-first’
                  businesses which can build compounding moats through ecosystem
                  creation, network effects, proprietary information or ability
                  to stack value-add layers.
                </Text>
              </ListItem>
              <br />
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  <span style={{ fontWeight: 'bold' }}>
                    Over 70% of unicorns in India by this definition are
                    platform businesses.
                  </span>
                  We foresee the forthcoming decade as the era of "Platform
                  businesses as India's digital economy is expected to surpass
                  $1 Trillion by next decade and large scale platform first
                  businesses will emerge in our focus sectors. Some examples of
                  Platform businesses are: Flipkart, Amazon, Zepto, Udaan,
                  Moglix, Progcap, Yubi, Zomato, Nyka, Ola, Sharechat,
                  Pratilipi, Pharmeasy, Urban Company, Livspace, and Myntra.
                </Text>
              </ListItem>
              <br />
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  Platform businesses can create sustainable competitive
                  advantages as they’re able to operate at an intersection of
                  supply side economies of scale (scale benefits), demand side
                  economies of scale (network effects) and data/proprietary
                  intelligence.
                </Text>
              </ListItem>
            </UnorderedList>
            <br />
            <br />
            <Text as="span" variant="blogAnswer" py="16px">
              Our standout performers/emerging winners within our portfolio have
              consistently been platform-based companies. These businesses have
              shown significant potential for growth and value creation. Ex-
              GripInvest, Wintwealth, Showroom, UnnatiAgri. Platform companies
              have demonstrated resilience, particularly during the challenging
              times brought about by the COVID-19 pandemic and the market
              downturn in 2022.
            </Text>
          </Box>
        </Box>

        {/* Question 5 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            5. Fund II plans to engage with institutional LPs. How do you see
            these partnerships shaping Gemba’s investment strategy and impact on
            the startup ecosystem?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Our investment strategy will not undergo any change since we
              already operate as an institutional VC Fund. Being a first-time
              fund manager, our Fund-I was small, and hence we never approached
              any institutional LPs. <br /> <br />
              Gemba Capital operates with a highly engaged model, fostering
              strong relationships and maintaining open and timely communication
              with our limited partners (LPs). As an institutional fund from the
              outset, we have established robust processes and an LP webportal
              for records and regularly sharing bi-annual reports that align
              with global reporting standards. <br /> <br />
              With Fund-II, we have a portfolio to showcase and with a target of
              $30Mn, we should be able to attract capital from institutional
              LPs. It will be a very good sign for the founders and the startup
              ecosystem if more domestic and international institutional LPs
              start investing micro-VC fund like ours. Indian seed/ pre-seed
              stage startup ecosystem requires more institutional capital to be
              deployed through single-stage VC funds like Gemba Capital. <br />{' '}
              <br />
              Institutional LPs who operate businesses in our focus sectors have
              additional synergies of working along with us to identify early
              winners and innovative startups for strategic opportunities as
              well. Such institutional LPs will also provide invaluable guidance
              to our portfolio companies.
            </Text>
          </Box>
        </Box>

        {/* Question 6 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            6. What are the key attributes you look for in founders during the
            pre-seed and seed stages? How do you evaluate their ability to build
            world-class companies?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              <span style={{ fontWeight: 'bold' }}> Founder market fit:</span>{' '}
              We focus extensively on the founder's work and personal background
              to assess founder market fit, viewing it as an important parameter
              to take the evaluation to the next steps. We also have an in-house
              Founder Market Fit framework that allows us to assess the founders
              we are investing in effectively.
            </Text>
            <Image
              src="https://static.levocdn.com/WGLBUT82/Screenshot2024-12-24at11231PM-ZnMwUQy339FV.png"
              width="70%"
              mx="auto"
              my="12px"
            />
            <Text w="100%" textAlign="center" variant="blogAnswer" pb="16px">
              <span
                style={{
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  textAlign: 'center',
                  margin: '0 auto',
                  width: '100%',
                }}
              >
                Founders Attribute Framework
              </span>{' '}
            </Text>
          </Box>
        </Box>
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            7. Gemba Capital emphasizes building lasting relationships. How do
            you nurture these relationships with your portfolio companies and
            founders?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              VC is a peoples’ business. We are in the services business where
              our network is our net worth. People and deep relationships keep
              this business away from becoming a mere financial and
              transactional in nature. Network effects also show prominently in
              this industry. We nurture our relationships by listening and being
              genuinely interested in solving the problems of the founders and
              adding value. By being a friend to them who also criticizes and
              shows the right way/path. We insist on getting MIS and provide
              feedback, whenever necessary. <br /> <br />
              We strive to provide value beyond just capital, actively
              supporting portfolio companies in multiple areas such as customer
              introductions, fundraising and strategic planning. Founders
              recognise the immense value we bring to the cap table, which sets
              us apart. We act as trusted sounding boarding for founders and
              actively encourage open and transparent dialogue with the founders
              wherein, they can freely discuss business challenges, seek advice,
              and share any concerns with us. <br /> <br />
              Our Venture Partners (VP) also play a critical role in their
              domain and are like extended investment team members for us and
              our portfolio founders. There have been many instances, where we
              despite not being the largest investor on the cap table have added
              10x more value to the founder than the lead investor. Some of our
              founders have become LPs or helped us in getting LPs, are our
              cheerleaders, sent us deals and so on.
            </Text>
          </Box>
        </Box>
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            8. How do you perceive the evolution of the Indian startup
            ecosystem, especially in early-stage funding? What role does a
            micro-VC play in this growth story?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Micro-VCs address a big gap in funding. Angel cheques are Rs. 10
              lakhs to 1 Cr normally. VCs <span>&gt;$75Mn</span>
              , want to write a Rs. 8 Cr+ cheque to meet their ownership targets
              and deploy the fund in time. Micro-VCs address this gap in funding
              between Rs. 1 Cr to Rs. 8 Cr. <br /> <br />
              Micro-VCs are the institutional investor for the founder, who adds
              substantial value and makes the Company/founders ready for the
              next round of funding. This is not an Optionality cheque for the
              micro-VC unlike receiving $1M from a $500M Fund. This is no
              foot-in-the door strategy and hence Partner level engagement is
              possible for the founders who take money from micro-VCs, which
              otherwise is not possible in the case of large VCs. <br /> <br />
              There is no signaling bias – if a micro-VC doesn’t participate in
              the next round of funding, which becomes a major issue if you have
              a large fund in the seed round not participating or leading the
              next round. Seed stage founders’ now prefer working with micro-VCs
              over larger funds due to their agility in decision-making,
              offering low-friction cheques and willingness to collaborate with
              other micro-VCs. <br /> <br />
              Founders’ have also realised that barring a few business models,
              you do not need a lot of cash when you don’t have PMF. Too much
              capital, sets off a string of wrong foundational decisions in
              company building and impairs your ability to raise the next round
              as well. <br /> <br />
              Multi-stage strategies have not worked in India, unlike the US and
              some of the ‘imported’ concepts like Power Law are US market-based
              concepts – which might not work in India, given the Indian market
              is very different from the US. You will see stage specific and
              sector specific expert micro-VC Funds thriving as the Indian
              startup ecosystem matures and finds more depth. <br /> <br />
              Currently, the Indian startup ecosystem is 3rd largest in the
              world. India's economy is projected to grow from USD 3.75 Tn to
              USD 6 Tn by 2030 and overall digital economy is projected to grow
              from $100Bn in 2021 to $1Trillion by 2030, driven by factors like
              growing online domestic consumption, positive economic outlook,
              government stability and initiatives, and advanced digital public
              infrastructure.
            </Text>
          </Box>
        </Box>
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            9. As an investor, what are the top lessons you’ve learned from the
            successes and challenges faced by your portfolio companies?
          </Heading>
          <Box>
            <UnorderedList>
              <Text variant="blogAnswer" fontSize="18px" mb="12px">
                <span style={{ fontWeight: 'bold' }}>
                  Lessons learned from portfolio companies’ success
                </span>
              </Text>
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  Companies that prioritize capital efficiency and maintain a
                  low burn rate can effectively navigate fundraising challenges
                  during downturns. Such companies do not spend and raise a lot
                  of capital till they see signs of PMF.
                </Text>
              </ListItem>
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  Building a product from first principles based on constant
                  customer feedback always wins.
                </Text>
              </ListItem>
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  Pivoting fast and more importantly knowing when to pivot. Such
                  companies do not fall for false positives.
                </Text>
              </ListItem>
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  Culture within the company to focus on raw numbers and data to
                  take decisions.
                </Text>
              </ListItem>
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  Ability to hire and retain great talent in the team.
                </Text>
              </ListItem>
            </UnorderedList>
            <br /> <br />
            {/* 2 */}
            <UnorderedList>
              <Text variant="blogAnswer" fontSize="18px" mb="12px">
                <span style={{ fontWeight: 'bold' }}>
                  Lessons learned from portfolio companies’ challenges
                </span>
              </Text>
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  Struggling to identify effective monetization strategies early
                  on is a signal that PMF is not happening.
                </Text>
              </ListItem>
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  Business models that heavily rely on high cash burn, where
                  capital is a moat are not the right models for micro-VCs like
                  us to invest in.
                </Text>
              </ListItem>
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  Founder’s inability to crack GTM is often the reason why
                  companies die.
                </Text>
              </ListItem>
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  Operating in a crowded market, with low defensibility product
                  - such companies find it tough to raise further capital
                </Text>
              </ListItem>
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  Throwing people at a problem instead of solving it through
                  tech/processes never works.
                </Text>
              </ListItem>
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  No tech cofounder and solo founder – such companies also find
                  it tough to scale fast.
                </Text>
              </ListItem>
            </UnorderedList>
          </Box>
        </Box>
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            10. What is your long-term vision for Gemba Capital? How do you
            envision its role in shaping India’s entrepreneurial landscape?
          </Heading>
          <Box>
            <UnorderedList>
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  We aspire to become India’s leading seed-focused institutional
                  fund, supporting ambitious entrepreneurs targeting large,
                  high-growth markets. Over the next decade, we aim to invest in
                  areas where founders can create impactful startups by
                  addressing underserved domestic markets.
                </Text>
              </ListItem>{' '}
              <br />
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  We will focus on nurturing our portfolio while making capital
                  allocation decisions aimed at maximizing returns for our
                  limited partners.
                </Text>
              </ListItem>{' '}
              <br />
              <ListItem>
                <Text as="span" variant="blogAnswer" py="16px">
                  In the next ten years, we plan to launch another 3 flagship
                  seed funds, taking our total to 5 funds by 2034, besides doing
                  Continuity Funds as well. In total managing ~Rs. 4,000 Cr AUM
                  by 2034. We aspire to be the investor of first choice for
                  founders for early-stage deals in India's startup ecosystem.
                </Text>
              </ListItem>
            </UnorderedList>
          </Box>
        </Box>
      </Box>
      <Heading
        variant="blogQuestion"
        lineHeight="30px"
        pt="16px"
        fontStyle="italic"
        p="12px 12px 0px"
      >
        The content in this section is curated by Team IVCA. For any feedback,
        connect with&nbsp;
        <Link
          href="mailto:paromita.sinha@ivca.in"
          target="_blank"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          paromita.sinha@ivca.in
        </Link>
      </Heading>
    </Container>
  </>
);

export default FundInFocusFirstInvesting;
